<template>
  <div>
    <div class="container">
      <div class="title">
        <div class="bold">
          Select how you are accessing this camera:
        </div>
        <div class="selection">
          <div class="radio">
            <input
              id="type"
              v-model="type"
              type="radio"
              :name="radioGroup"
              value="nvr"
            >
            <label for="nvr"> NVR </label>
          </div>
          <div class="radio">
            <input
              id="type"
              v-model="type"
              type="radio"
              :name="radioGroup"
              value="internal"
            >
            <label for="internal"> Internal IP </label>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown container">
      <div
        class="title"
        @click="showDropdown=!showDropdown"
      >
        <div class="bold">
          Manufacturer:
        </div>
        {{ camera.manufacturer || 'Choose Manufacturer' }}
        <div
          v-if="!showDropdown"
          class="arrow"
        >
          ▾
        </div>
        <div
          v-else
          class="arrow"
        >
          ▴
        </div>
      </div>

      <div
        v-if="showDropdown"
        class="menu content"
      >
        <a
          v-for="manufacturer in manufacturers"
          id="manufacturer"
          :key="manufacturer"
          class="manufacturer"
          @click="handleClick(manufacturer)"
        >
          {{ manufacturer }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { manufacturers } from '@/libraries/onboard/manufacturers'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'CameraGeneralInfo',
  props: {
    index: {
      type: Number,
    },
    camera: {
      type: Object,
    },
  },
  data () {
    return {
      showDropdown: false,
      type: undefined,
    }
  },
  computed: {
    ...mapGetters({
      defaultManufacturer: 'onboard/defaultManufacturer',
      defaultType: 'onboard/defaultType',
      cameras: 'onboard/cameras',
    }),
    manufacturers () {
      return manufacturers
    },
    radioGroup () {
      return `accessType-${this.index}`
    },
  },
  methods: {
    handleClick (manufacturer) {
      this.showDropdown = false
      const set = {
        cameraId: this.camera.id,
        fieldId: 'manufacturer',
        value: manufacturer,
      }
      this.setCameraFields(set)
      this.setDefaultManufacturer(this.selectedForm)
      // this.$emit('manufacturer', manufacturer)
    },
    ...mapMutations({
      setDefaultManufacturer: 'onboard/setDefaultManufacturer',
      setDefaultType: 'onboard/setDefaultType',
      setCameraFields: 'onboard/setCameraFields',
    }),
    save (e) {
      this.type = e.target.value
      const set = {
        cameraId: this.camera.id,
        fieldId: 'type',
        value: e.targe.value,
      }
      this.setCameraFields(set)
    },
  },
  watch: {
    type (newValue, oldValue) {
      const set = {
        cameraId: this.camera.id,
        fieldId: 'type',
        value: newValue,
      }
      this.setCameraFields(set)
      this.$emit('type', this.type)
    },
  },
  mounted () {
    this.type = this.camera.type
  },
}
</script>
<style scoped>
.dropdown.container {
    color: #EFF2F7;
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease-out;
    padding: 0;
    margin: 10px;
    width: 40%;
  }

.title {
    display: flex;
    align-items: center;
    height: 44px;
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    font-family: 'Lato', 'Avenir', 'Helvetica', sans-serif;
    color: black;
    text-align: center;
    justify-content: center;
  }

.dropdown.container:hover .title {
    border: 2px solid rgba(50, 64, 87, 1);
    transition: border 150ms ease;
    cursor: pointer;
  }

.dropdown.container .menu.content{
    display: flex;
    position: absolute;
    visibility: initial;
    flex-direction: column;
    width: 100%;
    /* background: #324057; */
    opacity: 1;
    height: auto;
    position: relative;
    overflow: hidden;
    transform: translateY(0);
  }

.dropdown.container .menu.content .manufacturer {
    height: 3.1428571429rem;
    background: #EFF2F7;
    border: 1px solid black;
    color: #324057;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin: 0;
    transition: color 300ms ease, background-color 300ms ease;
  }

.dropdown.container .menu.content .manufacturer:hover {
    background: #324057;
    color: #f3f4f5;
    cursor: pointer;
  }

.arrow {
  margin-left: 10px;
}
.radio {
  margin-right: 15px;
}

.input {
  margin-bottom: 10px;
}

.label {
  font-size: 16px;
  font-weight: bold;
  flex-shrink: 1;
  box-sizing: border-box;
  margin: 0.2857142857rem .1785714286rem;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.bold {
  font-weight: bold;
  margin-right: 10px;
}

.selection {
  display: flex;
  flex-direction: row;
  margin-right: 5px;
}
</style>
